import cx from 'classnames'; // для удобного объединения классов
import React from 'react';
import loaderIcon from '../assets/loaderIcon.png';
import styles from './Loader.module.scss';

const Loader = ({ size = 'medium', ...props }) => {
  return (
    <div className={cx(styles.loader, styles[size])} {...props}>
      <img src={loaderIcon} alt="loading" />
    </div>
  );
};

export default Loader;
